import { createContext, type ReactNode } from 'react';

const OBSidebarContext = createContext<ReactNode>(null);

export default OBSidebarContext;
